<template>
  <v-layout
      fill-height
      row
      wrap
  >
    <v-flex xs12>
      <router-view/>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  name: "OperationsHistoryParent",
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">

</style>
